import {AnimationLogoEventRequestParams} from "./animation-logo-event-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";

export class AnimationLogoGoalEventRequestParams extends AnimationLogoEventRequestParams {
  id: Number;
  rotate: Number;

  constructor(id: Number, isHomeCompetitor: Boolean) {
    super({resourceName: 'website/animations'});

    this.id = id;
    this._width = 80;
    this.rotate = isHomeCompetitor ? 180 : 0;
    this.ratio = 1;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.GIF;
  }
}
